// Email block model + email-safe HTML serializer for the drag-and-drop designer.
let _seq = 0;
const uid = () => `blk_${Date.now().toString(36)}_${(_seq++).toString(36)}`;

export const BLOCK_TYPES = [
  { type: 'heading', label: 'Heading' },
  { type: 'text', label: 'Text' },
  { type: 'image', label: 'Image' },
  { type: 'button', label: 'Button' },
  { type: 'divider', label: 'Divider' },
  { type: 'spacer', label: 'Spacer' },
  { type: 'columns', label: '2 Columns' },
];

export function defaultBlock(type) {
  const base = { id: uid(), type };
  switch (type) {
    case 'heading':
      return { ...base, text: 'Your heading', level: 'h2', align: 'left', color: '#0B2942', fontSize: 26 };
    case 'text':
      return { ...base, html: 'Write something engaging for your readers here.', align: 'left', color: '#334155', fontSize: 15 };
    case 'image':
      return { ...base, src: '', alt: '', align: 'center', width: 100, linkUrl: '' };
    case 'button':
      return { ...base, label: 'Click here', url: 'https://caretechcompare.co.uk', bg: '#00A79D', color: '#ffffff', align: 'center', radius: 8 };
    case 'divider':
      return { ...base, color: '#e5e7eb', thickness: 1 };
    case 'spacer':
      return { ...base, height: 24 };
    case 'columns':
      return { ...base, left: 'Left column text.', right: 'Right column text.', color: '#334155', fontSize: 15 };
    default:
      return base;
  }
}

const esc = (s) => String(s == null ? '' : s);

function blockRow(b) {
  const FONT = 'font-family:Arial,Helvetica,sans-serif;';
  switch (b.type) {
    case 'heading': {
      const size = b.level === 'h1' ? Math.max(b.fontSize, 30) : b.level === 'h3' ? Math.min(b.fontSize, 20) : b.fontSize;
      return `<tr><td style="padding:14px 28px 6px;">
        <${b.level} style="margin:0;${FONT}color:${b.color};font-size:${size}px;line-height:1.25;text-align:${b.align};font-weight:700;">${esc(b.text)}</${b.level}>
      </td></tr>`;
    }
    case 'text':
      return `<tr><td style="padding:8px 28px;">
        <div style="${FONT}color:${b.color};font-size:${b.fontSize}px;line-height:1.6;text-align:${b.align};">${esc(b.html)}</div>
      </td></tr>`;
    case 'image': {
      if (!b.src) {
        return `<tr><td style="padding:12px 28px;"><div style="background:#eef2f6;border:1px dashed #cbd5e1;border-radius:8px;color:#94a3b8;${FONT}font-size:13px;text-align:center;padding:28px;">Image</div></td></tr>`;
      }
      const img = `<img src="${esc(b.src)}" alt="${esc(b.alt)}" width="${b.width}%" style="width:${b.width}%;max-width:100%;display:inline-block;border:0;outline:none;text-decoration:none;" />`;
      const inner = b.linkUrl ? `<a href="${esc(b.linkUrl)}" target="_blank" style="border:0;text-decoration:none;">${img}</a>` : img;
      return `<tr><td align="${b.align}" style="padding:12px 28px;text-align:${b.align};">${inner}</td></tr>`;
    }
    case 'button':
      return `<tr><td align="${b.align}" style="padding:16px 28px;text-align:${b.align};">
        <a href="${esc(b.url)}" target="_blank" style="display:inline-block;background:${b.bg};color:${b.color};text-decoration:none;padding:13px 28px;border-radius:${b.radius}px;${FONT}font-weight:700;font-size:15px;">${esc(b.label)}</a>
      </td></tr>`;
    case 'divider':
      return `<tr><td style="padding:8px 28px;"><div style="border-top:${b.thickness}px solid ${b.color};font-size:0;line-height:0;">&nbsp;</div></td></tr>`;
    case 'spacer':
      return `<tr><td style="height:${b.height}px;line-height:${b.height}px;font-size:0;">&nbsp;</td></tr>`;
    case 'columns':
      return `<tr><td style="padding:8px 28px;">
        <table width="100%" cellpadding="0" cellspacing="0" role="presentation"><tr>
          <td width="50%" valign="top" style="padding-right:10px;${FONT}color:${b.color};font-size:${b.fontSize}px;line-height:1.6;">${esc(b.left)}</td>
          <td width="50%" valign="top" style="padding-left:10px;${FONT}color:${b.color};font-size:${b.fontSize}px;line-height:1.6;">${esc(b.right)}</td>
        </tr></table>
      </td></tr>`;
    default:
      return '';
  }
}

export function blocksToHtml(blocks) {
  const rows = (blocks || []).map(blockRow).join('\n');
  return `<table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="background:#f5f8fa;padding:24px 0;">
  <tr><td align="center">
    <table width="600" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;max-width:600px;background:#ffffff;border-radius:12px;">
      ${rows}
    </table>
  </td></tr>
</table>`;
}
